import React, { useEffect, useState } from "react";
import {  Spinner } from "reactstrap";
const AdminUserDataUpdateCount = ({ ...props }) => {
    const [load, setload] = useState(true)
    
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(props.userId),
        ParametersId: Number(props.parametersId),
        activeStatus:"O",
        employmentId: 0,
        employmentRefId: 0
    });


    const getdata = async () => {
       
      
        const sendData = {
            UserId: Number(props.userId),
            MonthId: Number(props.month),
            EmploymentRefId: props.parent,
            YearId: Number(props.year),
        }
       /* //console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK+'api/Main/Dashdata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                   
                   
                    if (data !== "No data") {
                        setFormData({
                            ...formData,
                            activeStatus: data.activeStatus,
                            employmentId: data.employmentId,
                            employmentRefId: data.employmentRefId
                        });
                      
                    } else {
                        setFormData({
                            ...formData,
                            activeStatus: "O",
                            employmentId: data.employmentId,
                            employmentRefId: data.employmentRefId
                        });
                    }
                   
                    setload(false)
                })


    };

    

    







    useEffect(() => {
        if (Number(props.year) > 0 && Number(props.month) > 0) {
            setload(true)
            getdata()
        }
 

    }, [props.year, props.month, props.userId, props.parent])




    return (
        load ? <Spinner color="success" /> :formData.activeStatus === "A" ? <> <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>  <b style={{ fontSize: 18 }}>  D</b></> : formData.activeStatus === "S" ? <> <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>  <b style={{ fontSize: 18 }}> S</b></> : <> <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>  <b style={{ fontSize: 18 }}> N</b></>);
};

export default AdminUserDataUpdateCount;
